import { Component, Input, OnInit, Signal, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Subject } from 'rxjs';
import { finalize, takeUntil } from 'rxjs/operators';
import { PendingChangesService } from 'src/app/shared/services/pending-change.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { ConfirmModalModel } from '@crdigital/crdigital-ui-sdk';
import { ConfirmStatus } from '@crdigital/crdigital-ui-sdk';
import { AdminAuthService } from 'src/app/shared/services/auth.service';

import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MsalService } from '@azure/msal-angular';

@Component({
    selector: 'account-settings-menu',
    templateUrl: './account-settings-menu.component.html',
    styleUrls: ['./account-settings-menu.component.scss'],
    imports: [MatIconModule, MatMenuModule, RouterModule]
})
export class AccountSettingsMenuComponent implements OnInit {
  jwtHelper = new JwtHelperService();
  @Input() isExpanded: boolean = true;
  @Input() isMobileScreen: boolean = false;

  private unsubscribe$: Subject<void> = new Subject<void>();
  public userIsEditing: Signal<boolean> = signal(false);

  constructor(private pendingChangesService: PendingChangesService, private authService: MsalService, private adminAuthService: AdminAuthService) {
    this.initPendingChanges();
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  public initPendingChanges(): void {
    this.userIsEditing = toSignal(this.pendingChangesService.userIsEditing, { initialValue: false });
  }

  public initConfirmedSave(): void {
    this.pendingChangesService.changeRoute$.pipe(takeUntil(this.unsubscribe$)).subscribe((route) => {
      if (route === 'logout') {
        this.logout();
      }
    });
  }

  public logoutClickEvent(): void {
    if (this.userIsEditing()) {
      const confirmModalModel: ConfirmModalModel = {
        title: 'You Have Unsaved Changes',
        subTitle: 'Do you want to save these changes before leaving the page?',
        confirmBottomLabel: 'Save',
        cancelBottomLabel: "No, I don't want to save",
      };
      this.pendingChangesService.openConfirmModal(confirmModalModel).subscribe((confirm) => {
        switch (confirm) {
          case ConfirmStatus.save:
            this.pendingChangesService.save.next('logout');
            break;
          case ConfirmStatus.close:
            this.pendingChangesService.userIsEditing.next(false);
            this.logout();
            break;
          default:
        }
      });
    } else {
      this.logout();
    }
  }

  public logout(): void {
    this.authService.logoutRedirect();

    this.adminAuthService.logOut();
  }

  get preferredUsername(): string {
    return this.adminAuthService.preferredUsername;
  }
}
